import { render, staticRenderFns } from "./ProductStockForm.vue?vue&type=template&id=8a39e740&"
import script from "./ProductStockForm.vue?vue&type=script&lang=js&"
export * from "./ProductStockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a39e740')) {
      api.createRecord('8a39e740', component.options)
    } else {
      api.reload('8a39e740', component.options)
    }
    module.hot.accept("./ProductStockForm.vue?vue&type=template&id=8a39e740&", function () {
      api.rerender('8a39e740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/basic/stock/modules/ProductStockForm.vue"
export default component.exports